import { IConfig } from '@vivli/shared/infrastructure/interface';
import { useEffect, useState } from 'react';
import { environment } from '@vivli/core/environments';
import { IAnonmyousApi, IPortalConfig } from '@vivli/core/infrastructure/interface';
import { AssignedAppTypeEnum } from '@vivli/shared/infrastructure/enum';

interface IConfigContextHook {
    anonApi: IAnonmyousApi;
    assignedAppType: AssignedAppTypeEnum;
    portalConfig: IPortalConfig;
}

export const useAppConfig = ({ anonApi, assignedAppType, portalConfig }: IConfigContextHook): IConfig => {
    const { getConfig } = anonApi;
    const [config, setConfig] = useState<IConfig>(null);
    const { getPortalConfig } = portalConfig;

    useEffect(() => {
        if (!assignedAppType || config) {
            return;
        }

        const configSub = getConfig().subscribe({
            next: (config) => {
                let configResult = { ...config };
                if (!configResult.signupEnabled) {
                    configResult.b2CSignInPolicyName = 'B2C_1_VivliSignInOnly';
                }

                configResult = getPortalConfig(configResult);

                // handle local override to view request results app
                if (environment.viewRequestResultsOnly) {
                    configResult.viewRequestResultsOnly = true;
                }

                setConfig({
                    ...configResult,
                    assignedAppType,
                });
            },
        });

        return () => {
            configSub.unsubscribe();
        };
    }, [assignedAppType]);

    return config;
};
